<!-- New Code -->
<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{ getDialogTitle() }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <mat-dialog-content class="">
    <div class="main-form">
      <form [formGroup]="CouponForm" (ngSubmit)="submitData()" novalidate>
        <!-- Coupon Type -->
        <div class="row">
          <div class="col-lg-12 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.CouponType}}<span class="text-danger" *ngIf="!IsPreviewTrue">*</span>
              </mat-label>
              <mat-form-field style="width: 100%">
                <mat-select placeholder="Select Coupon Type" formControlName="CouponType"
                  [ngClass]="{'preview-mode': IsPreviewTrue}">
                  <mat-option [value]="CouponTypeEnum.Special">{{LabelConstants.Special}}</mat-option>
                  <mat-option [value]="CouponTypeEnum.General">{{LabelConstants.General}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-error *ngIf="submitted && GetCouponFormConntrols['CouponType'].errors?.['required']">
                {{ErrorMessages.CouponTypeRequired}}
              </mat-error>
            </div>
          </div>
        </div>
        <!-- Coupon Name -->
        <div class="row">
          <div class="col-lg-12 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.CouponCode}}<span class="text-danger" *ngIf="!IsPreviewTrue">*</span>
              </mat-label>
              <mat-form-field style="width: 100%" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput placeholder="Enter Coupon Code" formControlName="CouponCode"
                  oninput="this.value = this.value.toUpperCase().replace(/[^A-Z0-9]/g, '').substring(0, 6)">
                <span *ngIf="!IsPreviewTrue && !isEditing" matSuffix class="auto-generate"
                  (click)="generateCouponCode()">{{LabelConstants.AutoGenerate}}</span>
              </mat-form-field>
              <mat-error *ngIf="submitted && GetCouponFormConntrols['CouponCode'].errors?.['required']">
                {{ErrorMessages.CouponCode}}
              </mat-error>
            </div>
          </div>
        </div>
        <!--Coupon Description-->
        <div class="row">
          <div class="col-lg-12 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.CouponDescription}}</mat-label>
              <mat-form-field style="width: 100%" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <textarea matInput maxlength="500" placeholder="Coupon Description...."
                  formControlName="CouponDescription"></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- Start Date / End Date -->
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.StartDate}}<span class="text-danger" *ngIf="!IsPreviewTrue">*</span>
              </mat-label>
              <mat-form-field style="width: 100%" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput placeholder="Select Start Date" [min]="currentDate" [matDatepicker]="startDate"
                  (dateChange)="validateCouponCodeDate()" formControlName="StartDate" id="date" readonly
                  (click)="openDatepicker()" />
                <mat-datepicker-toggle matSuffix [for]="startDate">
                </mat-datepicker-toggle>
                <mat-datepicker #startDate></mat-datepicker>
              </mat-form-field>
              <mat-error *ngIf="submitted && GetCouponFormConntrols['StartDate'].errors?.['required'] ">
                {{ErrorMessages.CouponStartDateRequired}}
              </mat-error>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.EndDate}}<span class="text-danger" *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field style="width: 100%" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput placeholder="Select End Date" [min]="currentDate" [matDatepicker]="endDate"
                  (dateChange)="validateCouponCodeDate()" formControlName="EndDate" id="date" readonly
                  (click)="openEndDatePicker()" />
                <mat-datepicker-toggle matSuffix [for]="endDate">
                </mat-datepicker-toggle>
                <mat-datepicker #endDate></mat-datepicker>
              </mat-form-field>
              <mat-error *ngIf="submitted && GetCouponFormConntrols['EndDate'].errors?.['required'] ">
                {{ErrorMessages.CouponEndDateRequired}}
              </mat-error>
              <mat-error *ngIf="IsSelectedDateValid && !GetCouponFormConntrols['EndDate'].errors?.['required'] ">
                {{ErrorMessages.CouponCodeDateInvalid}}
              </mat-error>
            </div>
          </div>
        </div>
        <!-- No of Passes / Expiry Days -->
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.DiscountType}}<span class="text-danger" *ngIf="!IsPreviewTrue">*</span>
              </mat-label>
              <mat-form-field style="width: 100%" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <mat-select placeholder="Select Discount Type" formControlName="DiscountType"
                  (selectionChange)="updateSelectedDiscountType($event)" [ngClass]="{'preview-mode': IsPreviewTrue}">
                  <mat-option [value]="discountTypes.Flat">{{LabelConstants.Flat}}</mat-option>
                  <mat-option [value]="discountTypes.Percentage">{{LabelConstants.Percentage}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-error *ngIf="submitted && GetCouponFormConntrols['DiscountType'].errors?.['required']">
                {{ ErrorMessages.CouponDiscountTypeRequired }}
              </mat-error>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="mb-3">
              <mat-label *ngIf="selectedDiscountType === discountTypes.Flat">{{LabelConstants.Flat}}<span
                  class="text-danger" *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-label *ngIf="selectedDiscountType === discountTypes.Percentage">{{LabelConstants.Percentage}}<span
                  class="text-danger" *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field style="width: 100%" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput formControlName="Price" type="text" *ngIf="selectedDiscountType == discountTypes.Flat"
                  [maxlength]="selectedDiscountType === discountTypes.Flat ? maxPriceLength : maxPercentageLength"
                  [placeholder]="selectedDiscountType === discountTypes.Flat ? 'Enter Price' : 'Enter Percentage'"
                  oninput="
                  this.value = this.value
                    .replace(/^\s+|[^0-9.]/g, '')
                    .replace(/(\..*)\./g, '$1')
                    .replace(/^(\d*\.\d{0,2}).*/g, '$1');
                  " />
                <input matInput formControlName="Price" type="text" *ngIf="selectedDiscountType != discountTypes.Flat"
                  [maxlength]="selectedDiscountType === discountTypes.Flat ? maxPriceLength : maxPercentageLength"
                  [placeholder]="selectedDiscountType === discountTypes.Flat ? 'Enter Price' : 'Enter Percentage'"
                  oninput="
                                  this.value = this.value
                                    .replace(/^\s+|[^0-9.]/g, '')
                                    .replace(/(\..*)\./g, '$1')
                                    .replace(/^(\d*\.\d{0,2}).*/g, '$1');
                                  if (parseFloat(this.value) > 100.00 ) this.value = '100.00';" />
                <span matSuffix class="pound-sign"> <i
                    [ngClass]="selectedDiscountType === discountTypes.Flat ? 'fa-solid fa-money-bill' : 'fa-solid fa-percent'"
                    class="pound-sign"></i></span>
              </mat-form-field>
              <mat-error *ngIf="submitted && GetCouponFormConntrols['Price'].errors?.['required']">
                {{ selectedDiscountType === discountTypes.Flat ? ErrorMessages.CouponPriceRequired :
                ErrorMessages.CouponPercentageRequired }}
              </mat-error>
            </div>
          </div>
        </div>
        <div class="dialogue-footer">
          <button class="btn btn-primary" *ngIf="!IsPreviewTrue && !isEditing" type="submit">
            {{LabelConstants.Add}}
          </button>
          <button class="btn btn-primary" *ngIf="!IsPreviewTrue && isEditing" type="submit">
            {{LabelConstants.Update}}
          </button>
          <button class="btn btn-info" *ngIf="!View" (click)="cancel()" type="button">
            {{LabelConstants.Cancel}}
          </button>
        </div>
      </form>
    </div>
  </mat-dialog-content>
</div>